
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Ticket, Trophy, DollarSign, X } from 'lucide-react';

const NotificationBanner = () => {
  const [currentNotification, setCurrentNotification] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const notifications = [
    {
      type: 'jackpot',
      icon: <DollarSign className="w-5 h-5" />,
      message: 'PowerBall Jackpot has reached $5 Million! Play now for your chance to win.',
      action: 'Play Now',
      bgColor: 'bg-green-100 border-green-300',
      textColor: 'text-green-800',
      buttonColor: 'bg-green-600 hover:bg-green-700'
    },
    {
      type: 'winner',
      icon: <Trophy className="w-5 h-5" />,
      message: 'Congratulations to Sarah M. from NSW who won $25,000 in last night\'s draw!',
      action: 'See Results',
      bgColor: 'bg-yellow-100 border-yellow-300',
      textColor: 'text-yellow-800',
      buttonColor: 'bg-yellow-600 hover:bg-yellow-700'
    },
    {
      type: 'draw',
      icon: <Ticket className="w-5 h-5" />,
      message: 'Next Oz Lotto draw is tomorrow at 8:00 PM AEDT. Don\'t miss out!',
      action: 'Buy Ticket',
      bgColor: 'bg-blue-100 border-blue-300',
      textColor: 'text-blue-800',
      buttonColor: 'bg-blue-600 hover:bg-blue-700'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentNotification((prev) => (prev + 1) % notifications.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [notifications.length]);

  if (!isVisible) return null;

  const notification = notifications[currentNotification];

  return (
    <div className={`${notification.bgColor} border-b ${notification.textColor} px-4 py-3`}>
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          {notification.icon}
          <span className="text-sm font-medium">{notification.message}</span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            className={`${notification.buttonColor} text-white text-xs px-3 py-1`}
          >
            {notification.action}
          </Button>
          <button
            onClick={() => setIsVisible(false)}
            className={`${notification.textColor} hover:opacity-70`}
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationBanner;
